/* global algoliaSearchLocalizedData */
import {liteClient as algoliasearch} from 'algoliasearch/lite';
import instantsearch from './lib/instantsearch.js';
import {createDropdown} from './Dropdown.js';

const searchClient = algoliasearch(algoliaSearchLocalizedData.appID, algoliaSearchLocalizedData.apiKey);
const refinementListDropdowns = {};
let hitsCount = 0;
const algoliaContainer = document.getElementById('era-wp-algolia-container');
const mobileFilterButton = document.getElementById('mobile-filters-button');
const mobileFilterCloseButton = document.getElementById('mobile-filter-overlay-close-button');
const mobileFilterConfirmButton = document.getElementById('mobile-filter-overlay-confirm-button');
const customCombinedRangeWidget = (options) => ({
	init({helper, instantSearchInstance}) {
		const {container, min, max, attribute} = options;

		container.innerHTML = `
      <div id="range-input-container"></div>
      <div id="range-slider-container"></div>
    `;

		const rangeSliderContainer = container.querySelector('#range-slider-container');
		const rangeInputContainer = container.querySelector('#range-input-container');

		const rangeSlider = instantsearch.widgets.rangeSlider({
			container: rangeSliderContainer,
			attribute,
			min,
			max,
			tooltips: true,
		});

		const rangeInput = instantsearch.widgets.rangeInput({
			container: rangeInputContainer,
			attribute,
			templates: {
				separatorText: ' - '
			},

		});

		instantSearchInstance.addWidgets([rangeSlider, rangeInput]);
	},
});

if (mobileFilterCloseButton) {
	mobileFilterCloseButton.addEventListener('click', function () {
		document.getElementById('mobile-filter-overlay').classList.remove('active');
	});
}

if (mobileFilterConfirmButton) {
	mobileFilterConfirmButton.addEventListener('click', function () {
		document.getElementById('mobile-filter-overlay').classList.remove('active');
	});

}
if (mobileFilterButton) {
	mobileFilterButton.addEventListener('click', function () {
		document.getElementById('mobile-filter-overlay').classList.toggle('active');
	});

}

if (typeof algoliaSearchBlockData !== 'undefined') {
	algoliaSearchLocalizedData.indexName = algoliaSearchBlockData['era_algolia_block_index'];
}
let viewType = 'is-style-gridview';
if (algoliaContainer) {
	viewType = algoliaContainer.dataset.viewType ?? 'is-style-gridview';
}
let indexName = `${algoliaSearchLocalizedData.environment}_${algoliaSearchLocalizedData.indexName}`;

const search = instantsearch({
	indexName: indexName,
	searchClient,
	routing: {
		stateMapping: instantsearch.stateMappings.singleIndex(indexName),
	},
});
// console.log('ALGOLIA SEARCH DATA:', algoliaSearchLocalizedData);
let activeFilters = algoliaSearchLocalizedData.activeFilters;

if (typeof algoliaSearchBlockData !== 'undefined') {
	let facets = algoliaSearchBlockData['era_algolia_block_visible_facets'] || [];
	activeFilters = Array.isArray(facets) ? facets : [facets];
}

activeFilters.forEach(function (filter) {
	if (filter === 'price') {
		refinementListDropdowns[filter] = createDropdown(
			customCombinedRangeWidget,
			{
				cssClasses: {
					root: 'ais-Dropdown--rangeslider',
				},
				closeOnChange: false,
				buttonText({items}, html) {
					return getFilterLabel(algoliaSearchLocalizedData.translations.filters[filter] ?? filter, html);
				}
			}
		);
	}
	else if (filter === 'country_destinations') {
		refinementListDropdowns['country_destinations'] = createDropdown(
			instantsearch.widgets.hierarchicalMenu,
			{
				closeOnChange: false,
				buttonText({items}, html) {
					return html`${getFilterLabelWithCount(algoliaSearchLocalizedData.translations.filters[filter] ?? filter, items, html)}`;
				},
				cssClasses: {
					// root: facetHasPreSelectedRefinement(filter) ? 'ais-Dropdown--opened' : '',
					root: 'ais-Dropdown--opened',
				},
			}
		);
	}
	else {
		if (filter === 'is_on_sale') {
			return;
		}
		refinementListDropdowns[filter] = createDropdown(
			instantsearch.widgets.refinementList,
			{
				closeOnChange: false,
				buttonText({items}, html) {
					if (algoliaSearchLocalizedData.hasOwnProperty('single_country_search') && filter === 'destinations') {
						// console.log(  algoliaSearchLocalizedData.single_country_search );
						let label = algoliaSearchLocalizedData.single_country_search;
						const arrow = algoliaSearchLocalizedData.icons['chevron-right'];
						return html`<span class="facet-dropdown__label">${label}</span><span class="facet-dropdown__arrow">${arrow}</span>`;
					}
					// return 'test';
					return html`${getFilterLabelWithCount(algoliaSearchLocalizedData.translations.filters[filter] ?? filter, items, html)}`;
				},
				cssClasses: {
					// root: facetHasPreSelectedRefinement(filter) ? 'ais-Dropdown--opened' : '',
					root: 'ais-Dropdown--opened',
				},
			}
		);
	}
});

if (algoliaContainer) {
	const broadcastRefinement = instantsearch.connectors.connectRefinementList((renderOptions, isFirstRender) => {
		const {items, widgetParams, instantSearchInstance} = renderOptions;
		const selectedValues = items.filter(i => i.isRefined).map((i) => i.value);
		const publicItems = items.map(({label, value, count, isRefined}) => ({
			label,
			value,
			count,
			isRefined,
		}));

		const broadcast = {
			attribute: widgetParams.attribute,
			selectedValues,
			ts: Date.now()
		}

		window.dispatchEvent(new CustomEvent('ais:refinementList:updated', {
			detail: broadcast
		}));
	});
	if (viewType === 'is-style-gridview') {
		search.addWidgets([
			instantsearch.widgets.infiniteHits({
				container: "#hits",
				cssClasses: {
					root: 'wc-block-grid has-multiple-rows',
					list: 'product-card-grid product-card-grid--columns-3',
					item: 'wc-block-grid__product',
					loadMore: 'wp-block-button__link wp-element-button load-more-button',
				},
				templates: {
					showMoreText(data, { html }) {
						return html`${algoliaSearchLocalizedData.translations.showMoreFacets}`;
					},
					item(hit, {html, components}) {
						if (algoliaSearchLocalizedData.hasOwnProperty('index_type_mapping') && 'product' !== algoliaSearchLocalizedData.index_type_mapping) {
							if ('hotel' === algoliaSearchLocalizedData.index_type_mapping) {
								// console.log('HOTELS', hit);

								const hotelRating = (hit) => {
									if (!hit.stars) {
										return '';
									}
									let stars = parseFloat(hit.stars);
									let full_stars = Math.floor(stars);
									let half_star = (stars - full_stars) >= 0.5 ? 1 : 0;
									let empty_stars = 5 - full_stars - half_star;

									return html`
										<div class="era-star-rating">
											${Array.from({length: full_stars}).map(() => html`
												<div class="era-star-rating__star"></div>`)}
											${half_star ? html`
												<div class="era-star-rating__star era-star-rating__star--half"></div>` : ''}
											${Array.from({length: empty_stars}).map(() => html`
												<div class="era-star-rating__star era-star-rating__star--empty"></div>`)}
										</div>`;
								}

								const hotelFacts = (hit) => {
									if ( ! hit.hasOwnProperty( 'facts' ) ) {
										return '';
									}
									return html `<ul class="hit-hotel__facts">
										${hit.facts.map(fact => html`<li class="hit-hotel__fact">${fact}</li>`)}
									</ul>`;
								}

								const hotelExcerpt = (hit) => {
									if (!hit.excerpt) {
										return '';
									}

									function truncate(text, maxLength = 100, suffix = "...") {
										if (text.length > maxLength) {
											return text.slice(0, maxLength) + suffix;
										}
										return text;
									}

									const truncatedText = truncate(hit.excerpt, 100); // Apply truncation here

									return html`
										<div class="hotel-info"><p>${truncatedText}</p></div>`; // Use the truncated text
								};

								const destinationLabel = () => {
									if ( ! hit.hasOwnProperty( 'destinations' ) || ! hit.destinations.length ) {
										return '';
									}

									const allDestinations = hit.destinations;
									if (Array.isArray(allDestinations) && allDestinations.length > 0) {
										return allDestinations.map((destination, index) => {
											return html`
											<div class="product-labels__label has-white-background-color">
												${destination}
											</div>`;
										});
									} else {
										return '';
									}
								};


								return html`
									<a href="${hit.url}" class="product-card">
										<div class="product-labels">
											${destinationLabel()}
										</div>
										<div class="product-card__image">
											<!-- Image -->
											<img src="${getHitImage(hit)}" alt="${hit.title}"
											     class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" style="${getImageStyle(hit)}" loading="lazy" />
										</div>
										<div class="product-card__content">
											${hotelRating(hit)}
											<h4 class="wp-block-heading product-card__title">${hit.title}</h4>
											${hotelFacts(hit)}
											<div class="icon-button has-primary-background-color" aria-hidden="true">
												<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11"
												     viewBox="0 0 12 11" fill="none" aria-hidden="true">
													<path d="M8.78141 4.8333L5.20541 1.2573L6.14808 0.314636L11.3334 5.49997L6.14808 10.6853L5.20541 9.74264L8.78141 6.16664H0.666748V4.8333H8.78141Z"
													      fill="white"/>
												</svg>
											</div>
										</div>
									</a>`;
							}
							// elseif(algoliaSearchLocalizedData.index_type_mapping === 'climate'){} ???
						} else {
							// console.log('HIT:', hit);
							// console.log('Product:', {
							// 	title: hit.title,
							// 	price: hit.price,
							// 	index: search.helper.state.index, // Log the current index
							// });
							const url = () => {

								if (hit.product_type[0] === 'simple') {
									// console.log(hit.product_type);
									return html`?add-to-cart=${hit.post_id}`;
								}
								return hit.url;
							}


							const buttonReadMore = () => {
								if (hit.product_type[0]) {
									return html`
										<div class="product-card__read-more"
										     role="button">${algoliaSearchLocalizedData.translations['readMore']}
										</div>`;
								}
							}

							const onSaleBadge = () => {
								if (!hit.is_on_sale) {
									return '';
								}
								return html`
									<div class="era-hit__on-sale wc-block-grid__product-onsale">On Sale</div>`;
							}

							/**
							 * Fetch correct dynamic data for country labels using hit.countries
							 * Create foreach loop to iterate over all country labels for individual hits (products)
							 * (one product can have several countries)
							 * @returns {*|string}
							 */
							const countryLabel = () => {
								if (!hit.countries) {
									return '';
								}

								const allCountries = hit.countries;
								if (Array.isArray(allCountries) && allCountries.length > 0) {
									return allCountries.map((country, index) => {
										// console.log(`Hit: ${hit.objectID} Country ${index + 1}: ${country}`);
										return html`
											<div class="product-labels__label has-white-background-color">
                                            <span class="svg-wrapper" aria-label="era-hit__product-country-label">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                     viewBox="0 0 16 16" fill="none">
                                                    <path d="M8 15.8188L3.75734 11.5761C2.91823 10.737 2.34679 9.66789 2.11529 8.50401C1.88378 7.34013 2.0026 6.13373 2.45673 5.03738C2.91086 3.94103 3.6799 3.00396 4.66659 2.34467C5.65328 1.68539 6.81332 1.3335 8 1.3335C9.18669 1.3335 10.3467 1.68539 11.3334 2.34467C12.3201 3.00396 13.0891 3.94103 13.5433 5.03738C13.9974 6.13373 14.1162 7.34013 13.8847 8.50401C13.6532 9.66789 13.0818 10.737 12.2427 11.5761L8 15.8188ZM11.3 10.6334C11.9526 9.98078 12.397 9.14926 12.577 8.24403C12.7571 7.33879 12.6646 6.40051 12.3114 5.54781C11.9582 4.69512 11.36 3.96632 10.5926 3.45356C9.82519 2.9408 8.92296 2.66711 8 2.66711C7.07704 2.66711 6.17481 2.9408 5.40739 3.45356C4.63997 3.96632 4.04183 4.69512 3.68861 5.54781C3.33539 6.40051 3.24294 7.33879 3.42297 8.24403C3.603 9.14926 4.04741 9.98078 4.7 10.6334L8 13.9334L11.3 10.6334ZM8 8.66678C7.64638 8.66678 7.30724 8.5263 7.05719 8.27625C6.80715 8.0262 6.66667 7.68707 6.66667 7.33344C6.66667 6.97982 6.80715 6.64068 7.05719 6.39064C7.30724 6.14059 7.64638 6.00011 8 6.00011C8.35362 6.00011 8.69276 6.14059 8.94281 6.39064C9.19286 6.64068 9.33334 6.97982 9.33334 7.33344C9.33334 7.68707 9.19286 8.0262 8.94281 8.27625C8.69276 8.5263 8.35362 8.66678 8 8.66678Z"
                                                          fill="#262B43" fill-opacity="0.9"/>
                                                </svg>
                                            </span>
												${country}
											</div>`;
									});
								} else {
									// console.log(`Hit: ${hit.objectID} - No countries found or invalid data.`);
									return '';
								}
							};


							/**
							 * TODO:
							 * Fecth correct dynamic data for duration labels
							 * @returns {*|string}
							 */
							const durationLabel = () => {
								if (!hit.duration) {
									return '';
								}
								return html`
									<div class="product-labels__label has-primary-background-color">
									<span class="svg-wrapper" aria-label="era-hit__product-duration-label">
										<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12"
										     viewBox="0 0 14 12" fill="none">
											<path d="M12.25 1H11V1.75C11 1.8875 10.8875 2 10.75 2H10.25C10.1125 2 10 1.8875 10 1.75V1H4V1.75C4 1.8875 3.8875 2 3.75 2H3.25C3.1125 2 3 1.8875 3 1.75V1H1.75C1.0625 1 0.5 1.5625 0.5 2.25V10.75C0.5 11.4375 1.0625 12 1.75 12H12.25C12.9375 12 13.5 11.4375 13.5 10.75V2.25C13.5 1.5625 12.9375 1 12.25 1ZM12.5 10.375C12.5 10.7188 12.2188 11 11.875 11H2.125C1.78125 11 1.5 10.7188 1.5 10.375V4.75C1.5 4.6125 1.6125 4.5 1.75 4.5H12.25C12.3875 4.5 12.5 4.6125 12.5 4.75V10.375ZM4 0.25C4 0.1125 3.8875 0 3.75 0H3.25C3.1125 0 3 0.1125 3 0.25V1H4V0.25ZM11 0.25C11 0.1125 10.8875 0 10.75 0H10.25C10.1125 0 10 0.1125 10 0.25V1H11V0.25Z"
											      fill="white"/>
										</svg>
									</span>
										${hit.duration} ${algoliaSearchLocalizedData.translations['durationDays']}
									</div>`;
							}

							const getMapImage = () => {
								if ( Object.hasOwn( hit, 'map_image' ) ) {
									let alt = algoliaSearchLocalizedData.translations['map_image_alt'].replace( '%s', hit.title );
									return html`<img class="product-card__map-image" loading="lazy"
													 src="${hit.map_image}" alt="${alt}"/>`;
								}
							}

							return html`
								<a href="${hit.url}" class="product-card">
									<div class="product-labels">
										${countryLabel()}
										${durationLabel()}
									</div>
									<div class="product-card__image">
										<img src="${getHitImage(hit)}" alt="${hit.title}"
										     class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" style="${getImageStyle(hit)}" loading="lazy" />
										${getMapImage()}
									</div>
									<div class="product-card__content">
										<h4 class="wp-block-heading product-card__title">${hit.title}</h4>
										<p class="wp-block-paragraph spacing-before--0 spacing-after--0 product-card__info">
											${hit.product_sub_title || ''}
										</p>
										<div class="product-card__price">
											<span>${algoliaSearchLocalizedData.translations['from']}</span> <span
												class="has-number-font-size">${getPriceMarkup(html, hit)},-</span></div>
										${buttonReadMore()}
										<div class="icon-button has-primary-background-color" aria-hidden="true">
											<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11"
											     viewBox="0 0 12 11" fill="none" aria-hidden="true">
												<path d="M8.78141 4.8333L5.20541 1.2573L6.14808 0.314636L11.3334 5.49997L6.14808 10.6853L5.20541 9.74264L8.78141 6.16664H0.666748V4.8333H8.78141Z"
												      fill="white"/>
											</svg>

										</div>
									</div>
								</a>
							`;
						}
					},
					empty(results, {html}) {
						let text = algoliaSearchLocalizedData.translations['hitNoResults'];
						let header = algoliaSearchLocalizedData.translations['hitNoResultsHeader'];
						return html`<h1 class="r-wp-algolia__no-results-header">${header}</h1>
						<h2 class="r-wp-algolia__no-results">${text}</h2>`;
					},
				},
			}),
		]);
	} else if (viewType === 'is-style-listview') {
		search.addWidgets([
			instantsearch.widgets.hits({
				container: "#hits",
				cssClasses: {
					// root: 'this-root-class-is-where',
					list: 'list-view',
					item: 'list-view item-table-row',
				},
				templates: {
					item(hit, {html, components}) {
						return html`
							<a href="${hit.url}" class="search-card">
								<div class="search-card__header">
									<h3 class="wp-block-heading spacing-before--0 spacing-after--0 has-heading-s-font-size has-text-color has-brand-color">
										${components.Highlight({
											"attribute": "title",
											"highlightedTagName": "mark",
											hit
										})}</h3>
								</div>
								<p class="wp-block-paragraph spacing-before--0 spacing-after--0">${hit.excerpt}</p>
							</a>`
					},
					empty(results, {html}) {
						let text = algoliaSearchLocalizedData.translations['hitNoResults'].replace('%s', results.query);
						let header = algoliaSearchLocalizedData.translations['hitNoResultsHeader'];
						return html`<h1 class="r-wp-algolia__no-results-header">${header}</h1>
						<h2 class="r-wp-algolia__no-results">${text}</h2>`;
					},
				},
			}),
		]);
	}


	search.addWidgets([
		instantsearch.widgets.stats({
			templates: {
				text(data, {html}) {
					let hits = data.nbHits;
					hitsCount = hits;
					if (data.hasOneResult) {
						return html`${algoliaSearchLocalizedData.translations['showResult']}`;
					} else if (data.hasManyResults) {
						let text = algoliaSearchLocalizedData.translations['showResults'];
						text = text.replace('%results%', hits);
						return html`${text}`;
					} else {
						return html`${algoliaSearchLocalizedData.translations['hitNoResultsHeader']}`;
					}
				}
			},
			container: "#filterCloseButtonProducts"
		}),
		instantsearch.widgets.stats({
			container: "#stats",
			templates: {
				text(data, {html}) {
					let hits = data.nbHits;
					if (data.hasOneResult) {
						return html`${algoliaSearchLocalizedData.translations['showResult']}`;
					} else if (data.hasManyResults) {
						let text = algoliaSearchLocalizedData.translations['showResults'];
						text = text.replace('%results%', hits);
						return html`${text}`;
					} else {
						return html`${algoliaSearchLocalizedData.translations['hitNoResultsHeader']}`;
					}
				}
			}
		}),
	]);

	if ( algoliaSearchLocalizedData.hasOwnProperty( 'single_country_search' ) ) {
		search.addWidgets( [
			instantsearch.widgets.clearRefinements( {
				container: "#clear-refinements",
				templates: {
					resetLabel: ( { hasRefinements }, { html } ) => {
						return html`${algoliaSearchLocalizedData.translations['clearFilters']}`
					},
				}
			} ),
			instantsearch.widgets.configure( {
				filters: `countries:"${algoliaSearchLocalizedData.single_country_search}"`,
			} ),
			broadcastRefinement({
				attribute: 'destinations'
			})
		], );
	} else {
		search.addWidgets( [
			instantsearch.widgets.clearRefinements( {
				container: "#clear-refinements",
				includedAttributes: [...activeFilters, ...['country_destinations.lvl0', 'country_destinations.lvl1']],
				templates: {
					resetLabel: ( { hasRefinements }, { html } ) => {
						return html`${algoliaSearchLocalizedData.translations['clearFilters']}`
					},
				}
			} ),
		] );
	}

	activeFilters.forEach(function (filter) {
		if (document.querySelector(`#${filter}`)) {
			if('country_destinations' === filter) {
				search.addWidgets( [
					refinementListDropdowns[filter]( {
						container: '#country_destinations',
						sortBy: ['name'],
						limit: 100,
						attributes: [
							"country_destinations.lvl0",
							"country_destinations.lvl1",
						],
						templates: {
							item(item, {html}) {
								const {url, label, count, isRefined} = item;

								return html`
									<div class="algolia-facets-item ${isRefined ? 'algolia-facets-item--active' : ''}"
										 role="checkbox"
										 aria-checked="${isRefined}"
										 data-attribute-name="${label}"
										 tabindex="0"
										 aria-label="${label} (${count})">
										<div class="algolia-facets-item-checkbox-wrapper"><input
												class="algolia-facet__checkbox" type="checkbox"
												${isRefined ? 'checked' : ''}
												tabindex="-1"/><label
												for="algolia-facet__checkbox"></label><span
												class="algolia-facets__facet">${label}</span></div>
										<span class="algolia-facets__count">(${count})</span></div>`;
							}
						},
					} )
				] );
			} else {
				search.addWidgets([
					refinementListDropdowns[filter]({
						container: `#${filter}`,
						attribute: filter,
						searchable: false,
						limit: 1000,
						sortBy: ['isRefined','name'],
						templates: {
							item(item, {html}) {
								const {url, label, count, isRefined} = item;

								return html`
									<div class="algolia-facets-item ${isRefined ? 'algolia-facets-item--active' : ''}"
										 role="checkbox"
										 aria-checked="${isRefined}"
										 data-attribute-name="${label}"
										 tabindex="0"
										 aria-label="${label} (${count})">
										<div class="algolia-facets-item-checkbox-wrapper"><input
												class="algolia-facet__checkbox" type="checkbox"
												${isRefined ? 'checked' : ''}
												tabindex="-1"/><label
												for="algolia-facet__checkbox"></label><span
												class="algolia-facets__facet">${label}</span></div>
										<span class="algolia-facets__count">(${count})</span></div>`;
							}
						}
					})
				]);
			}
		}

	});

	/**
	 * Sorting by price
	 * Set translation strings for options in sorting select
	 * Add widget
	 */

	let currentIndex = algoliaSearchLocalizedData.indexName;

	// if (currentIndex === 'products_drommerejser') {
	// 	// console.log('Current Index: ', currentIndex);
	// 	if (typeof algoliaSearchLocalizedData !== 'undefined' && algoliaSearchLocalizedData.translations) {
	// 		const sortingPriceLowToHighLabel = algoliaSearchLocalizedData.translations['SortingPriceLowToHigh'] || 'Price: Low to High';
	// 		const sortingPriceHighToLowLabel = algoliaSearchLocalizedData.translations['SortingPriceHighToLow'] || 'Price: High to Low';
	//
	//
	// 		search.addWidgets([
	// 			instantsearch.widgets.sortBy({
	//
	// 				container: "#sort-by",
	// 				items: [
	// 					{label: sortingPriceHighToLowLabel, value: 'DEV_products_drommerejser_price_desc'}, // Descending replica
	// 					{label: sortingPriceLowToHighLabel, value: 'DEV_products_drommerejser_price_asc'}, // Ascending replica
	// 				],
	// 				cssClasses: {
	// 					select: 'select',
	// 				},
	// 				transformItems(items) {
	// 					// Log the current sorting options
	// 					// console.log('Available sort options:', items);
	// 					return items;
	// 				},
	// 			}),
	// 		]);
	// 	}
	// }


	// if (currentIndex === 'hotels') {
	// 	// console.log('Current Index: ', currentIndex);
	//
	// 	if (typeof algoliaSearchLocalizedData !== 'undefined' && algoliaSearchLocalizedData.translations) {
	// 		const sortingHotelRatingLowToHighLabel = algoliaSearchLocalizedData.translations['SortingHotelRatingLowToHigh'] || 'Rating: Low to High';
	// 		const sortingHotelRatingHighToLowLabel = algoliaSearchLocalizedData.translations['SortingHotelRatingHighToLow'] || 'Rating: High to Low';
	//
	//
	// 		search.addWidgets([
	// 			instantsearch.widgets.sortBy({
	//
	// 				container: "#sort-by",
	// 				items: [
	// 					{label: sortingHotelRatingHighToLowLabel, value: 'DEV_hotels_stars_desc'},
	// 					{label: sortingHotelRatingLowToHighLabel, value: 'DEV_hotels_stars_asc'},
	// 				],
	// 				cssClasses: {
	// 					select: 'select',
	// 				},
	// 				transformItems(items) {
	// 					// Log the current sorting options
	// 					// console.log('Available sort options:', items);
	// 					return items;
	// 				},
	// 			}),
	// 		]);
	// 	}
	// }

	/**
	 * #0:
	 * Debugging logs
	 * #1:
	 * Ensure the default value is shown in the dropdown on page load
	 * Set the current index for the dropdown options
	 * Ensure the placeholder is always the default unless explicitly changed
	 * Find the dropdown and set its text
	 * #2:
	 * Check if any other option is selected
	 * #3:
	 *  Reset to placeholder if no valid selection exists
	 * #4:
	 * Log dropdown changes to confirm interaction
	 */

	search.on('render', () => {
		//#0 DEBUGGING LOGS
		// console.log('Render triggered');
		// console.log('Current index:', search.helper.state.index);
		// console.log('Render triggered for index:', search.helper.state.index);

		// const hitsContainer = document.querySelector('#hits');
		// if (hitsContainer) {
		// 	console.log(hitsContainer);
		// }

		//#1
		let currentIndexDropDown = search.helper.state.index;
		const dropdown = document.querySelector('#sort-by select');
		if (dropdown) {
			// if (!dropdown.hasAttribute('data-placeholder-added')) {
			// 	const placeholder = document.createElement('option');
			// 	if (currentIndexDropDown === 'products_drommerejser') {
			// 		placeholder.textContent = algoliaSearchLocalizedData.translations['sortingPricePlaceholder'];
			// 	} else if (currentIndexDropDown === 'hotels') {
			// 		placeholder.textContent = algoliaSearchLocalizedData.translations['sortingHotelRatingPlaceholder'];
			// 	}
			// 	placeholder.disabled = true; // Make it non-selectable
			// 	placeholder.selected = true; // Make it the default
			// 	dropdown.prepend(placeholder); // Add it as the first option
			// 	dropdown.setAttribute('data-placeholder-added', 'true'); // Mark as added
			// }

			//#2
			const hasSelection = Array.from(dropdown.options).some(option => option.selected && !option.disabled);

			//#3
			if (!hasSelection) {
				dropdown.options[0].selected = true; // Ensure placeholder is selected
			}
		}
	})

	//#4
	document.querySelector('#sort-by').addEventListener('change', (event) => {
		// console.log('Sorting option selected:', event.target.value);
		// console.log('Index changed to:', search.helper.state.index);
	});


	/**
	 * Old replica code START
	 */

// 	let replicas = algoliaSearchLocalizedData.sortBy;
// 	let sortByEnabled = false;
//
// 	if (typeof blockData !== 'undefined') {
// 		sortByEnabled = blockData.enable_sort_by === '1';
// 	}
//
// 	if (replicas && sortByEnabled) {
// 		replicas = replicas[algoliaSearchLocalizedData.indexName];
// 		replicas[algoliaSearchLocalizedData.indexName] = {
// 			'en': 'Relevance',
// 			'da': 'Relevans'
// 		};
// 		search.addWidgets([
// 			instantsearch.widgets.sortBy({
// 				container: "#sort-by",
// 				items: Object.entries(replicas).map(([key, value]) => ({
// 					label: value[algoliaSearchLocalizedData.currentLang],
// 					value: key
// 				})),
// 				cssClasses: {
// 					select: 'select',
// 				},
// 			}),
// 		]);
// 	} else {
// 		document.getElementById('sort-by').parentElement.style.display = 'none';
// 	}

	/**
	 * Old replica code END
	 */

}

if (typeof algoliaSearchBlockData !== 'undefined') {
	if (algoliaSearchBlockData['era_algolia_block_hits_per_page']) {
		search.addWidgets([
			instantsearch.widgets.configure({
				hitsPerPage: algoliaSearchBlockData['era_algolia_block_hits_per_page'],
			}),
		]);
	}
	if (algoliaSearchBlockData['era_algolia_block_enable_search'] === '1') {
		search.addWidgets([
			instantsearch.widgets.searchBox({
				container: "#searchbox",
				placeholder: algoliaSearchBlockData['era_algolia_block_search_field_placeholder'] ?? algoliaSearchLocalizedData.translations['searchPlaceholder'],
				showSubmit: false,
				showReset: false,
			})
		]);
	}
}

search.on('render', function () {
	let currentRefinements = search.helper.state.disjunctiveFacetsRefinements;
	let activeFilters = -1;
	for (const [key, values] of Object.entries(currentRefinements)) {
		activeFilters += values.length;
	}

	const activeFiltersElement = document.getElementById('activeFilters');

	if (activeFiltersElement) {
		activeFiltersElement.textContent = activeFilters > 0 ? `(${activeFilters})` : "";
	}
});

search.start();

// TODO: Check this method instead.
// https://www.algolia.com/doc/guides/building-search-ui/widgets/customize-an-existing-widget/js/#apply-default-value-to-widgets
if (typeof algoliaSearchBlockData !== 'undefined') {
	let preselected = algoliaSearchBlockData['era_algolia_block_preselected_attributes'] || [];
	if (preselected.length) {
		search.addWidget({
			init: (options) => {
				for (let i = 0; i < preselected.length; i++) {
					const split = preselected[i].split(':');
					options.helper.addDisjunctiveFacetRefinement(split[0], split[1]);
				}
			}
		});
	}
}

/**
 * Virtual replicas contains "virtual()" around the indexName, but Algolia expects the replica name used in the sortBy
 * widget without that part to work. This function removes the "virtual()" part of the index name if it is present.
 *
 * @param indexName
 * @returns {*}
 */
function replicaIndexName(indexName) {
	const match = indexName.match(/virtual\((.*?)\)/);
	return match ? match[1] : indexName;
}

/**
 * Check if the provided facet is defined as preselected in the block settings.
 *
 * @param facet
 * @returns {boolean}
 */
function facetHasPreSelectedRefinement(facet) {
	if (typeof algoliaSearchBlockData !== 'undefined') {
		let preselected = algoliaSearchBlockData['era_algolia_block_preselected_attributes'] || [];
		if (preselected.length) {
			for (let i = 0; i < preselected.length; i++) {
				const split = preselected[i].split(':');
				if (split[0] === facet) {
					return true;
				}
			}
		}
	}

	return false;
}

/**
 * Get Dropdown RefinementList buttonLabel with count, if any item is selected.
 *
 * @param label
 * @param items
 * @returns {string|*}
 */
function getFilterLabelWithCount(label, items,html) {
	let count = 0;
	let currentLang = algoliaSearchLocalizedData.currentLang;
	label = label[currentLang];
	for (const [key, values] of Object.entries(items)) {
		if (values.isRefined) {
			count++;
		}
	}

	const countSpan = count > 0 ? html`<span class="facet-dropdown__count">${count}</span>` : ''
	return html`<span class="facet-dropdown__label">${label} ${countSpan}</span>`;
}

/**
 * Get
 *
 * @param label
 * @returns {*}
 */
function getFilterLabel(label, html) {
	let currentLang = algoliaSearchLocalizedData.currentLang;
	label = label[currentLang];

	return html`<span class="facet-dropdown__label">${label}</span>`;
}

function getFilterLabelWithItems(label, items) {
	let itemNames = [];
	for (const [key, values] of Object.entries(items)) {
		if (values.isRefined) {
			itemNames.push(values.label);
		}
	}
	return itemNames.length > 0 ? `${label} (${itemNames.join(', ')})` : label;
}

/**
 * Format label-value pair.
 *
 * @param html
 * @param label
 * @param value
 * @returns {*}
 */
function getGridAttributeItem(html, label, value) {
	if (typeof value === 'undefined') {
		return html``;
	}
	value = Array.isArray(value) ? value.join(', ') : value;
	return html`
		<dl class="course-product-attributes">
			<dt class="course-product-attributes__tax">${label}</dt>
			<dd class="course-product-attributes__terms">
				${value}
			</dd>
		</dl>`;
}

/**
 * Format value as Badge.
 *
 * @param html
 * @param value
 * @param valueSuffix
 * @param classes
 * @returns {*}
 */
function getBadge(html, value, valueSuffix, classes) {
	if (value === 'undefined') {
		return html``;
	}

	return html`<span class="badge ${classes}">${value}${valueSuffix}</span>`;
}

/**
 * Get Categories as badges.
 *
 * @param html
 * @param hit
 * @returns {*}
 */
function getCategoriesBadges(html, hit) {
	return;
	return hit['categories_' + algoliaSearchLocalizedData.currentLang].map((value) => getBadge(html, value, '', ''));
}

/**
 * Get WooCommerce markup for price.
 *
 * @param html
 * @param hit
 * @returns {*}
 */
function getPriceMarkup(html, hit) {
	// console.log( hit.price );
	let price = hit.price;

	if (typeof price === 'undefined') {
		return html``;
	}
	let locale = 'da-DK';
	if (algoliaSearchLocalizedData.currentLang == 'en') {
		locale = 'en-GB';
	}
	price = new Intl.NumberFormat(locale).format(price);
	return html`<span class="woocommerce-Price-amount amount"><bdi>${price}</bdi></span>`;
}

function getHitImage( hit ) {
	if ( hit.hasOwnProperty( 'featured_image' ) && '' !== hit.featured_image ) {
		return hit.featured_image;
	}

	return algoliaSearchLocalizedData.fallbackImage;
}

function getImageStyle(hit){
	let style = '';
	if ( Object.hasOwn( hit, 'image_focus' ) ) {
		style += ' object-position:' + hit.image_focus + ';';
	}

	return style;
}

/**
 * WCAG (Web accessibility) functions
 * Find the focused facet, and add event.key to enable click event on "keydown "Enter""
 */
document.addEventListener('keydown', (event) => {
	const focusedFacet = document.activeElement;

	// Check if the focused element is a facet with role "checkbox"
	if (focusedFacet.getAttribute('role') === 'checkbox') {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault(); // Prevent default behavior

			// Simulate a click event to trigger existing Algolia behavior
			focusedFacet.click();
		}
	}
});

/**
 * WCAG (Web accessibility) functions
 * Expand or close depending on the state of the dropdown
 */
document.addEventListener('keydown', (event) => {
	if (event.key === 'Escape') {
		const openDropdown = document.querySelector('.ais-Dropdown-button[aria-expanded="true"]');
		if (openDropdown) {
			openDropdown.setAttribute('aria-expanded', 'false');

			const dropdownContentId = openDropdown.getAttribute('aria-controls');
			const dropdownContent = document.getElementById(dropdownContentId);

			if (dropdownContent) {
				dropdownContent.classList.add('hidden');
			}

			openDropdown.focus(); // Return focus to the button
		}
	}
});

/**
 * WCAG (Web accessibility) functions
 * Find Load more hits button, ais-Dropdown-buttons and sort by select dropdown and set correct aria-labels
 * Add keydown events
 */
search.on('render', () => {
	// Select the Load More button
	const loadMoreButton = document.querySelector('.wp-block-button__link.wp-element-button.load-more-button');

	if (loadMoreButton) {
		// Make it accessible by adding the required attributes
		loadMoreButton.setAttribute('role', 'button'); // Explicitly mark it as a button for assistive technologies
		loadMoreButton.setAttribute('aria-label', 'Load more results'); // Add a meaningful label
		loadMoreButton.setAttribute('tabindex', '0'); // Ensure it is tabbable

		// Optionally add a click event for fallback logic
		loadMoreButton.addEventListener('keydown', (event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault(); // Prevent default scrolling or other behavior
				loadMoreButton.click(); // Simulate a click
			}
		});
	}

	const sortBySelect = document.querySelector('.ais-SortBy-select select');

	if (sortBySelect) {
		// Add accessibility attributes to the select element
		sortBySelect.setAttribute('aria-label', 'Sort results'); // Accessible label
		sortBySelect.setAttribute('role', 'combobox'); // Mark it as a combobox
		sortBySelect.setAttribute('tabindex', '0'); // Ensure it is tabbable

		// Add a keydown event listener for the Enter key
		sortBySelect.addEventListener('keydown', (event) => {
			if (event.key === 'Enter') {
				event.preventDefault(); // Prevent default behavior
				const selectedOption = sortBySelect.options[sortBySelect.selectedIndex];
				// console.log(`Selected sorting: ${selectedOption.value}`); // Debugging

				// Trigger the change event to apply the selection
				sortBySelect.dispatchEvent(new Event('change'));
			}
		});

		// Handle the change event for debugging
		sortBySelect.addEventListener('change', () => {
			const selectedOption = sortBySelect.options[sortBySelect.selectedIndex];
			// console.log(`Sorting applied: ${selectedOption.value}`);
		});
	}
});

/**
 * _____________________________________________________________________________________________________________________
 * _____________________________________________________________________________________________________________________
 * _____________________________________________________________________________________________________________________
 */

/**
 * TRAVEL COMPONENT
 */

let travelComponentContainer = document.getElementById('era-wp-algolia-container--travel-component');
if ( travelComponentContainer ) {

	let travelComponentResultsPage = travelComponentContainer.getAttribute('data-results-page');
	let travelComponentIndex = travelComponentContainer.getAttribute('data-index');
	let travelComponentIndexName = `${algoliaSearchLocalizedData.environment}_${travelComponentIndex}`;
	const searchTravelComponent = instantsearch({
		indexName: travelComponentIndexName,
		searchClient,
		routing: {
			stateMapping: instantsearch.stateMappings.singleIndex(travelComponentIndexName),
		},
	});

	/**
	 * Travel component facets
	 */
	const travelComponentFacets =
		{

			country_destinations: createDropdown(
				instantsearch.widgets.hierarchicalMenu,
				{
					closeOnChange: false,
					buttonText({items}, html){
						return html`Vælg rejsemål`;
					},cssClasses: {
						root: 'ais-Dropdown',
					},
				},

			),
			category : createDropdown(
				instantsearch.widgets.refinementList,
				{
					closeOnChange: false,
					buttonText({items}, html) {
						return html`Vælg rejsetype`;
					},
					cssClasses: {
						root: 'ais-Dropdown',
					},
				}
			),
	}

	/**
	 * Helper function for appending clearRefinements buttons inside RefinementList
	 */
	const insideListClear = instantsearch.connectors.connectClearRefinements(
		(renderOptions) => {
			const { refine, hasRefinements, widgetParams } = renderOptions;
			const root = document.querySelector(widgetParams.container);
			if (!root) return;

			const list = root.querySelector('.ais-RefinementList, .ais-HierarchicalMenu');
			if (!list) return;

			// find facet search input (supports both built-in and custom)
			const getFacetInput = (scope) =>
				scope.querySelector('.ais-RefinementList-searchInput') ||
				scope.querySelector('.ais-SearchBox-input') ||
				scope.querySelector('.facet-local-search') ||
				scope.querySelector('input[type="search"]');

			let facetFooter = list.querySelector('.ais-Panel-body__footer');
			if ( ! facetFooter ) {
				facetFooter = document.createElement( 'div' );
				facetFooter.className = 'ais-Panel-body__footer';
				list.appendChild( facetFooter );
			} else {
				facetFooter = list.querySelector('.ais-Panel-body__footer');
			}

			let btn = facetFooter.querySelector('.facet-clear-inside');
			if (!btn) {
				btn = document.createElement('button');
				btn.type = 'button';
				btn.className = 'facet-clear-inside';
				btn.textContent = widgetParams.clearLabel || 'Ryd';
				facetFooter.appendChild(btn);
				// list.appendChild(li);

				btn.addEventListener('click', (e) => {
					e.preventDefault();

					// 1) clear refinements for this facet
					refine();

					// 2) clear the facet's search query + notify listeners
					const input = getFacetInput(root);
					if (input) {
						input.value = '';
						input.dispatchEvent(new Event('input',  { bubbles: true }));
						input.dispatchEvent(new Event('change', { bubbles: true }));
						input.focus();
					}

					// 3) unhide any items you may have hidden via client-side filtering
					list.querySelectorAll('.ais-RefinementList-item').forEach((item) => {
						if (!item.classList.contains('facet-clear-item')) {
							item.style.display = '';
							item.removeAttribute('aria-hidden');
							item.removeAttribute('tabindex');
						}
					});
				});
			} else {
				btn = facetFooter.querySelector('button.facet-clear-inside');
			}

			let closeBtn = facetFooter.querySelector('.facet-close');
			if (!closeBtn) {
				closeBtn = document.createElement('button');
				closeBtn.type = 'button';
				closeBtn.className = 'facet-close';
				closeBtn.textContent = widgetParams.closeLabel || 'Gem';
				facetFooter.appendChild(closeBtn);

				closeBtn.addEventListener( 'click', ( e ) => {
					e.preventDefault();
					const facetButton = root.querySelector( '.ais-Panel-header .ais-Dropdown-button' );
					facetButton.click();
				} );
			}

			// compute whether the button should be enabled
			const input = getFacetInput(root);
			const hasQuery = !!(input && input.value && input.value.trim().length);

			// also enable when the query yields zero visible items (so users can clear the query)
			const visibleCount = Array.from(list.querySelectorAll('.ais-RefinementList-item, .ais-HierarchicalMenu-item'))
				.filter((el) => !el.classList.contains('facet-clear-item'))
				.filter((el) => getComputedStyle(el).display !== 'none')
				.length;

			const shouldEnable = hasRefinements || hasQuery || visibleCount === 0;

			if (btn) {
				btn.disabled = !shouldEnable;
				btn.setAttribute('aria-disabled', shouldEnable ? 'false' : 'true');
			}

			// keep the enabled/disabled state in sync while typing
			if (input && !input.dataset._bindClearEnable) {
				input.dataset._bindClearEnable = '1';
				input.addEventListener('input', () => {
					const q = input.value.trim();
					const enable = hasRefinements || q.length > 0;
					if (btn) {
						btn.disabled = !enable;
						btn.setAttribute('aria-disabled', enable ? 'false' : 'true');
					}
				});
			}
		}
	);

	/**
	 * Global clear refinements (like insideListClear but global)
	 */
	const globalClear = instantsearch.connectors.connectClearRefinements(
		(renderOptions) => {
			const { refine, hasRefinements, widgetParams } = renderOptions;
			const root = document.querySelector(widgetParams.container);
			if (!root) return;

			// ensure a single button
			let btn = root.querySelector('.facet-clear-global');
			if (!btn) {
				btn = document.createElement('button');
				btn.type = 'button';
				btn.className = 'facet-clear-global ais-ClearRefinements-button';
				btn.textContent = widgetParams.label || 'Clear all filters';
				root.appendChild(btn);

				btn.addEventListener('click', (e) => {
					e.preventDefault();

					// 1) clear *all* refinements
					refine();

					// 2) clear *all* search inputs inside travel component
					const travelContainer = document.querySelector('#era-wp-algolia-container--travel-component');
					if (travelContainer) {
						const inputs = travelContainer.querySelectorAll(
							'.ais-SearchBox-input, .ais-RefinementList-searchInput, input[type="search"]'
						);
						inputs.forEach((input) => {
							input.value = '';
							input.dispatchEvent(new Event('input', { bubbles: true }));
							input.dispatchEvent(new Event('change', { bubbles: true }));
						});
					}
				});
			}

			// compute whether the button should be enabled
			const travelContainer = document.querySelector('#era-wp-algolia-container--travel-component');
			let hasQuery = false;
			if (travelContainer) {
				const inputs = travelContainer.querySelectorAll('.ais-SearchBox-input, input[type="search"]');
				hasQuery = Array.from(inputs).some((i) => i.value && i.value.trim().length > 0);
			}

			const shouldEnable = hasRefinements || hasQuery;
			btn.disabled = !shouldEnable;
			btn.setAttribute('aria-disabled', shouldEnable ? 'false' : 'true');
		}
	);

	searchTravelComponent.addWidgets([
		instantsearch.widgets.configure({ maxValuesPerFacet: 5000 }),
		instantsearch.widgets.stats({
			container: "#stats-travel-component",
			templates: {
				text(data, { html }) {
					const hits = data.nbHits;
					const searchBtn = document.querySelector('#travel-search-button');

					if (searchBtn) {
						if (data.hasOneResult) {
							searchBtn.textContent = algoliaSearchLocalizedData.translations['showResult'];
						} else if (data.hasManyResults) {
							let label = algoliaSearchLocalizedData.translations['showResults'];
							label = label.replace('%results%', hits);
							searchBtn.textContent = label;
						} else {
							searchBtn.textContent = algoliaSearchLocalizedData.translations['hitNoResultsHeader'];
						}
					}

					// Existing return for visible stats
					if (data.hasOneResult) {
						return html`${algoliaSearchLocalizedData.translations['showResult']}`;
					} else if (data.hasManyResults) {
						let text = algoliaSearchLocalizedData.translations['showResults'];
						text = text.replace('%results%', hits);
						return html`${text}`;
					} else {
						return html`${algoliaSearchLocalizedData.translations['hitNoResultsHeader']}`;
					}
				}
			}
		}),
		globalClear({
			container: '#global-clear',
			includedAttributes: ['country_destinations.lvl0','country_destinations.lvl1', 'product_cat'],
			label: 'Ryd filtre',
		}),
		travelComponentFacets.country_destinations( {
			container: "#tc-country_destinations",
			attributes:  ['country_destinations.lvl0','country_destinations.lvl1'],
			limit: 5000,
		}),
		insideListClear({
			container: '#tc-country_destinations',
			includedAttributes: ['country_destinations.lvl0','country_destinations.lvl1'],
			clearLabel: `${algoliaSearchLocalizedData.translations['clear']}`,
			closeLabel: `${algoliaSearchLocalizedData.translations['close']}`,
		}),
		travelComponentFacets.category( {
			container: "#tc-category",
			attribute:  'product_cat',
			searchable: true,
			searchablePlaceholder: `${algoliaSearchLocalizedData.translations['searchCategoryPlaceholder']}`,
			limit: 5000,
		}),
		insideListClear({
			container: '#tc-category',
			includedAttributes: ['product_cat'],
			clearLabel: `${algoliaSearchLocalizedData.translations['clear']}`,
			closeLabel: `${algoliaSearchLocalizedData.translations['close']}`,
		}),
	]);


	/**
	 * Search functionality for travel component facets
	 */

	(function () {
		const facetQueries = new Map();

		function makeFacetSearchWidget(containerSelector) {
			return {
				render() {
					const root = document.querySelector(containerSelector);
					if (!root) return;

					const input =
						root.querySelector('.ais-RefinementList-searchInput') ||
						root.querySelector('input[type="search"]');

					const list =
						root.querySelector('.ais-RefinementList-list') ||
						root.querySelector('ul');

					if (!input || !list) return;

					// Keep the current query across re-renders
					const savedQ = facetQueries.get(containerSelector) || '';
					if (input.value !== savedQ) input.value = savedQ;

					// Filter function
					const applyFilter = () => {
						const q = (input.value || '').trim().toLowerCase();
						facetQueries.set(containerSelector, q);

						// Show/hide list items based on label text
						list.querySelectorAll('.ais-RefinementList-item, li').forEach((li) => {
							if (li.classList.contains('facet-clear-item')) {
								// never hide the clear button
								li.style.display = '';
								li.removeAttribute('aria-hidden');
								li.removeAttribute('tabindex');
								return;
							}

							const label =
								li.querySelector('.ais-RefinementList-labelText') ||
								li.querySelector('.ais-RefinementList-label') ||
								li.querySelector('.ais-Highlight') ||
								li;
							const text = (label.textContent || '').trim().toLowerCase();
							li.style.display = !q || text.includes(q) ? '' : 'none';
						});
					};

					// Attach once
					if (!input.dataset._facetSearchBound) {
						input.dataset._facetSearchBound = '1';
						input.addEventListener('input', applyFilter);
					}

					// Re-apply after every InstantSearch render (list re-created)
					applyFilter();
				}
			};
		}

		// Register for your three facets
		searchTravelComponent.addWidgets([
			// makeFacetSearchWidget('#country'),
			// makeFacetSearchWidget('#destination'),
			makeFacetSearchWidget('#category'),
		]);
	})();

	/**
	 * Close dropdowns if an item is refined
	 * Eg:. If a facet is clicked and is active, we close the dropdown
	 */

	// searchTravelComponent.on('render', () => {
	// 	const travelContainer = document.querySelector('#era-wp-algolia-container--travel-component');
	// 	if (!travelContainer) return;
	//
	// 	// Loop over all facet wrappers inside travel component
	// 	travelContainer.querySelectorAll('.facet-wrappers').forEach(wrapper => {
	// 		// See if this wrapper has any selected refinements
	// 		const selected = wrapper.querySelector('.ais-RefinementList-item.ais-RefinementList-item--selected');
	// 		if (selected) {
	// 			const dropdownRoot = wrapper.querySelector('.ais-Dropdown.ais-Dropdown--opened');
	// 			if (dropdownRoot) {
	// 				// console.log('Closing dropdown for facet:', wrapper.id);
	// 				dropdownRoot.classList.remove('ais-Dropdown--opened');
	// 			}
	// 		}
	// 	});
	// });

	/**
	 * Close dropdowns if user clicks outside of travelcomponent
	 */
	document.addEventListener('click', (event) => {
		const travelContainer = document.querySelector('#era-wp-algolia-container--travel-component');
		if (!travelContainer) return;

		// If the click was *inside* the travel component, ignore it
		if (travelContainer.contains(event.target)) return;

		// Otherwise, close any open dropdowns inside the travel component
		travelContainer.querySelectorAll('.ais-Dropdown.ais-Dropdown--opened').forEach(openDropdown => {
			// console.log('Closing dropdown because click was outside travel component');
			openDropdown.classList.remove('ais-Dropdown--opened');
		});
	});

	/**
	 * WCAG Compliance
	 */
	function setFacetListTabindex(containerSelector) {
		const root = document.querySelector(containerSelector);
		if (!root) return;

		const apply = () => {
			const dropdown = root.querySelector('.ais-Dropdown');
			const list = root.querySelector('.ais-RefinementList-list');
			const button = root.querySelector('.ais-Dropdown-button');
			const closeBtn = root.querySelector('.ais-Dropdown-close');
			const searchInput = root.querySelector('.ais-SearchBox-input');
			const searchSubmit = root.querySelector('.ais-SearchBox-submit'); // NEW
			const facetClearItem = root.querySelector('.facet-clear-item');

			const items = list
				? Array.from(list.querySelectorAll('.ais-RefinementList-item:not(.facet-clear-item)'))
				: [];

			// Button is always part of tab order
			if (button) button.setAttribute('tabindex', '0');

			if (dropdown && dropdown.classList.contains('ais-Dropdown--opened')) {
				// Dropdown is OPEN → make items + buttons tabbable
				if (searchInput) searchInput.setAttribute('tabindex', '0');
				if (searchSubmit) searchSubmit.setAttribute('tabindex', '0'); // make submit tabbable only when open
				if (facetClearItem) facetClearItem.setAttribute('tabindex', '0');
				if (list) list.setAttribute('tabindex', '-1'); // UL should never be focusable

				items.forEach((li) => {
					li.setAttribute('tabindex', '0');
					li.setAttribute('role', 'option');

					const isSelected = li.classList.contains('ais-RefinementList-item--selected');
					li.setAttribute('aria-selected', isSelected ? 'true' : 'false');

					if (!li.dataset._facetKeyboardBound) {
						li.dataset._facetKeyboardBound = '1';

						li.addEventListener('keydown', (e) => {
							switch (e.key) {
								case 'Enter':
								case ' ':
									e.preventDefault();
									li.click(); // toggle refinement
									break;
								case 'Escape':
									e.preventDefault();
									dropdown.classList.remove('ais-Dropdown--opened');
									if (button) button.focus();
									break;
							}
						});
					}
				});

				if (closeBtn) closeBtn.setAttribute('tabindex', '0');
			} else {
				// Dropdown is CLOSED → only button is tabbable, everything else skipped
				if (searchInput) searchInput.setAttribute('tabindex', '-1');
				if (searchSubmit) searchSubmit.setAttribute('tabindex', '-1'); // hide submit button when closed
				if (facetClearItem) facetClearItem.setAttribute('tabindex', '-1');
				items.forEach((li) => li.setAttribute('tabindex', '-1'));
				if (closeBtn) closeBtn.setAttribute('tabindex', '-1');
				if (list) list.setAttribute('tabindex', '-1'); // UL never tabbable
			}
		};

		apply();

		// Watch for re-renders
		const mo = new MutationObserver(apply);
		mo.observe(root, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class', 'style'],
		});

		// Re-apply when facet search input changes (if present)
		const input = root.querySelector('.ais-RefinementList-searchInput, input[type="search"]');
		if (input && !input.dataset._facetTabindexBound) {
			input.dataset._facetTabindexBound = '1';
			input.addEventListener('input', apply);
		}
	}

	searchTravelComponent.on('render', () => {
		setFacetListTabindex('#country');
		setFacetListTabindex('#destination');
		setFacetListTabindex('#category');
	});

	/**
	 * Global Escape handler: close any open dropdown
	 */
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			const travelContainer = document.querySelector('#era-wp-algolia-container--travel-component');
			if (!travelContainer) return;

			travelContainer.querySelectorAll('.ais-Dropdown.ais-Dropdown--opened').forEach(d => {
				d.classList.remove('ais-Dropdown--opened');
				d.removeAttribute('data-open');
				// Return focus to its button
				const btn = d.querySelector('.ais-Dropdown-button');
				if (btn) btn.focus();
			});
		}
	});

	/**
	 * Debug: log focused element when tabbing
	 * Uncomment for console.logs
	 */
	// document.addEventListener('focusin', (e) => {
	// 	const el = e.target;
	// 	console.log(
	// 		'[Focus]',
	// 		`tag=<${el.tagName.toLowerCase()}>`,
	// 		`classes="${el.className}"`,
	// 		el.textContent?.trim()?.slice(0, 30)
	// 	);
	// });




	/**
	 * Click event for search button
	 * Takes data-attribute (data-results-page) from travel component ACF field
	 * And sets it as location for the results page when submitting query request
	 */

	document.getElementById('travel-search-button')?.addEventListener('click', (e) => {
		e.preventDefault();

		// Get the current UI state
		const uiState = searchTravelComponent.getUiState();

		// Serialize the state into a query string
		const searchParams = new URLSearchParams();

		if (uiState[travelComponentIndexName]) {
			const state = uiState[travelComponentIndexName];

			if (state.query) {
				searchParams.set('query', state.query);
			}

			if (state.refinementList) {
				for (const [facet, values] of Object.entries(state.refinementList)) {
					values.forEach(value => {
						searchParams.append(`refinementList[${facet}][]`, value);
					});
				}
			}
			if(state.hierarchicalMenu){
				for (const [facet, values] of Object.entries(state.hierarchicalMenu)) {
					values.forEach(value => {
						searchParams.append(`hierarchicalMenu[${facet}][]`, value);
					});
				}
			}
		}

		// Redirect to the results page with query string
		const baseUrl = (travelComponentResultsPage && travelComponentResultsPage.trim()) || '/find-rejse/';

		// Support absolute or relative URLs
		const url = new URL(baseUrl, window.location.origin);

		// Append current search params without clobbering any existing ones on baseUrl
		searchParams.forEach((value, key) => url.searchParams.append(key, value));

		window.location.href = url.toString();
	});

	searchTravelComponent.start();
}

/**
 * _____________________________________________________________________________________________________________________
 * _____________________________________________________________________________________________________________________
 * _____________________________________________________________________________________________________________________
 */